import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { useRouter } from 'next/router';
import { withTheme } from '@shared/lib';
import { Spacer, PaymentButton, Content } from '@shared/ui/atoms';
const UnreleasedServicePageView: FC = () => {
  const router = useRouter();
  return <Content.Margin bottom={16} mobBottom={8} minBottom={2}>
      <Wrapper>
        <StubServiceWrapper>
          <Spacer space={24} spacetablet={24} spacemob={24} />
          <Text>Новый сервис уже близко</Text>
          <Spacer space={12} spacetablet={12} spacemob={12} />
          <Description>Пополнение временно недоступно, следите за новостями</Description>
          <Spacer space={24} spacetablet={24} spacemob={24} />
          <ButtonWrapper>
            <PaymentButton title="НА ГЛАВНУЮ" onClick={() => router.push('/')} />
          </ButtonWrapper>
        </StubServiceWrapper>
      </Wrapper>
    </Content.Margin>;
};
export default UnreleasedServicePageView;
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wb3l66o",
  propsAsIs: false
});
const StubServiceWrapper = /*#__PURE__*/styled('div')({
  name: "StubServiceWrapper",
  class: "s2dyhsa",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.lg;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.lg;
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "t1k8sf43",
  propsAsIs: false,
  vars: {
    "t1k8sf43-0": [_exp()],
    "t1k8sf43-1": [_exp2(), "px"],
    "t1k8sf43-2": [_exp3()],
    "t1k8sf43-3": [_exp4(), "px"],
    "t1k8sf43-4": [_exp5()],
    "t1k8sf43-5": [_exp6(), "px"],
    "t1k8sf43-6": [_exp7(), "px"]
  }
}));
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.secondary;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp12 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.sm;
const Description = withTheme(/*#__PURE__*/styled('div')({
  name: "Description",
  class: "drmr7b9",
  propsAsIs: false,
  vars: {
    "drmr7b9-0": [_exp8()],
    "drmr7b9-1": [_exp9()],
    "drmr7b9-2": [_exp0(), "px"],
    "drmr7b9-3": [_exp1()],
    "drmr7b9-4": [_exp10(), "px"],
    "drmr7b9-5": [_exp11(), "px"],
    "drmr7b9-6": [_exp12(), "px"]
  }
}));
const ButtonWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonWrapper",
  class: "b1l33zbk",
  propsAsIs: false
});

require("./UnreleasedServicePageView.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./UnreleasedServicePageView.tsx");